/*
 * Sort control for the collection grid.
 *
 * The form works without JavaScript — it has a real submit button — so this
 * only removes the extra click: change the select, the form goes. The button is
 * hidden here rather than in CSS so that it stays usable when this script fails
 * to load or the element never upgrades.
 */
class CollectionSort extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.select = this.querySelector('select');
    if (!this.form || !this.select) return;

    this.button = this.querySelector('[data-sort-submit]');
    if (this.button) this.button.hidden = true;

    this.select.addEventListener('change', () => {
      this.form.submit();
    });
  }
}

if (!customElements.get('collection-sort')) {
  customElements.define('collection-sort', CollectionSort);
}
